import React from 'react';
import {
    Container,
    Grid,
    Typography,
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import PartnerCommissionTable from './PartnerCommissionTable';

export default function PartnerCommissionListView() {
    const { t } = useTranslation();

    return (
        <Page
            title={t('navbar.partnercommission')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.partnercommission')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <PartnerCommissionTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}